import React from 'react';
import "./Signup.css";
import {useAuth} from "../Contexts/AuthContexts"
import { Link, useNavigate } from "react-router-dom";
import {CALL_API_URL} from '../Services/CallService'

function Signup() {
    // const { getFirestore } = require('firebase-admin/firestore');
    const navigate = useNavigate();
    const provider = useAuth();
    // const db = getFirestore();

    const userHomePage = () => {
      navigate("/UserHome")
    }

    const [formData, setFormData] = React.useState(
    {
        firstName: "", 
        lastName: "", 
        userType: "",
        email: "",
        password: "",
        myEvents: []
    })
    const [improper, setImproper] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState("")
    
    function handleChange(event) {
      const {name, value, type, checked} = event.target
      setFormData(prevFormData => {
          return {
              ...prevFormData,
              [name]: type === "checkbox" ? checked : value
          }
      })
    }

    async function handleSubmit(event) {
      try {
        setError('')
        setLoading(true)
        event.preventDefault()
        if (!ensureProperValues()) {
          await fetch(`${CALL_API_URL}/api/users`, {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(formData)
          })
          await provider.signup(formData.email, formData.password)
          userHomePage()
        }
      } catch (err) {
        setError(JSON.stringify(err, Object.getOwnPropertyNames(err)))
       }
       setLoading(true)
    }


    function ensureProperValues() {
      if (formData.firstName === "" || formData.lastName === "" || formData.userType === "") {
        setImproper(true)
        return true
      } else if (formData.firstName.substring(0,1) === " ") {
        return rWhiteSpace(formData.firstName, 1)
      } else if (formData.lastName.substring(0,1) === " ") {
        return rWhiteSpace(formData.lastName, 1)
      }
      setImproper(false)
      return false
    }

    function rWhiteSpace(a, b) {
        if (a.length === b) {
          setImproper(true)
          return true
        }
        if (a.substring(b, b + 1) === " ") {
          return rWhiteSpace(a, b + 1)
        }
        setImproper(false)
        return false
    }

    return (
      <div className="form-container">
        <form className="form" onSubmit={handleSubmit}>
              <h1 className="font-semibold text-[35px] mb-[10px]">Sign Up</h1>
              <p>{error}</p>
              <input className="form--input"
                  type="text"
                  placeholder="First Name"
                  onChange={handleChange}
                  name="firstName"
                  value={formData.firstName}
              />
              <input className="form--input"
                  type="text"
                  placeholder="Last Name"
                  onChange={handleChange}
                  name="lastName"
                  value={formData.lastName}
              />
              <input className="form--input"
                  type="email"
                  placeholder="Email"
                  onChange={handleChange}
                  name="email"
                  value={formData.email}
              />
              <input className="form--input"
                  type="password"
                  placeholder="Password"
                  onChange={handleChange}
                  name="password"
                  value={formData.password}
              />
              <div className="form--role">
                <label className="form--roleName" htmlFor="userType">What is your role?</label>
                <br />
                <select 
                    id="userType" 
                    value={formData.userType}
                    onChange={handleChange}
                    name="userType"
                    className="form--marketing"
                >
                    <option></option>
                    <option value="student">Student</option>
                    <option value="teacher">Teacher</option>
                    <option value="organizer">Organizer</option>
                </select>
              </div>
              <br />
              <br />
              {improper && <p>Invalid credentials!</p>}
              <button disabled={loading} className="form--submit">Sign Up</button>
              <div className="mt-[10px]">
                  Already have an account? <Link to="/login" className="underline">Log In</Link>
              </div>
          </form>
        </div>
    )
  }
  
  export default Signup;